import React, { FC } from 'react';
import { SignatureType } from '../services/types';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  date: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    width: 'max-content',
  },
  error: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    width: 'max-content',
    backgroundColor: "tomato",
    borderRadius: "20px",
    padding: "2px 15px"
  },
  pending: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    width: 'max-content',
    backgroundColor: "#fb8c00",
    borderRadius: "20px",
    padding: "2px 15px"
  },
  complete: {
    fontSize: 14,
    width: 'max-content',
    backgroundColor: "#4caf50",
    borderRadius: "20px",
    padding: "2px 15px"
  }
}));

type Props = {
  signature: SignatureType
}

export const Cellstatus: FC<Props> = ({ signature }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      {[signature.is_complete, signature.is_declined, signature.has_error].every(status => status === false) && (
      <Typography className={classes.pending}>
        {t("documents:status-pending")}
      </Typography>
      )}
      {signature.is_complete && (
      <Typography className={classes.complete}>
        {t("documents:status-complete")}
      </Typography>
      )}
      {signature.is_declined && (
      <Typography className={classes.error}>
        {t("documents:status-declined")}
      </Typography>
      )}
      {signature.has_error && (
      <Typography className={classes.error}>
        {t("documents:status-has-error")}
      </Typography>
      )}
    </>
  );
};
